<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="专业名称" prop="majorId">
        <el-select
          v-model="queryParams.majorId"
          placeholder="请选择专业"
          clearable
          filterable
          style="width: 200px"
        >
          <el-option
            v-for="major in majorOptions"
            :key="major.majorId"
            :label="major.majorName"
            :value="major.majorId"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="学期" prop="xueQi">
        <el-select
          v-model="queryParams.xueQi"
          placeholder="请选择学期"
          clearable
          style="width: 200px"
        >
          <el-option
            v-for="item in semesterOptions"
            :key="item.value"
            :label="item.label"
            :value="item.label"
          />
        </el-select>
      </el-form-item>
     
      <el-form-item label="阶段" prop="stage">
        <el-select
          v-model="queryParams.stage"
          placeholder="请选择阶段"
          clearable
          style="width: 200px"
        >
          <el-option
            v-for="item in stageOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
        >新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="success"
          plain
          icon="el-icon-edit"
          size="mini"
          :disabled="single"
          @click="handleUpdate"
        >修改</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="danger"
          plain
          icon="el-icon-delete"
          size="mini"
          :disabled="multiple"
          @click="handleDelete"
        >删除</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="warning"
          plain
          icon="el-icon-download"
          size="mini"
          @click="handleExport"
        >导出</el-button>
      </el-col>
    </el-row>

    <el-table v-loading="loading" :data="omdstageconfigList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="主键ID" align="center" prop="id" />
      <el-table-column label="专业名称" align="center" prop="majorName" />
      <el-table-column label="学期" align="center" prop="xueQi">
        <template slot-scope="scope">
          {{ formatSemester(scope.row.xueQi) }}
        </template>
      </el-table-column>
      <el-table-column label="阶段" align="center" prop="stageDisplay">
      </el-table-column>

      <el-table-column label="阶段自定义名称" align="center" prop="stageName" />
      <!-- <el-table-column label="备注" align="center" prop="remark" /> -->
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
           
          >修改</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 分页组件 -->
    <el-pagination background class="pagination-container" v-show="total > 0" :current-page="queryParams.pageNum"
      :page-sizes="[5, 10, 20, 50]" :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />


    <!-- 添加或修改阶段名管理对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="专业名称" prop="majorId">
          <el-select
            v-model="form.majorId"
            placeholder="请选择专业"
            clearable
            filterable
            style="width: 100%"
          >
            <el-option
              v-for="major in majorOptions"
              :key="major.majorId"
              :label="major.majorName"
              :value="major.majorId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="学期" prop="xueQi">
          <el-select
            v-model="form.xueQi"
            placeholder="请选择学期"
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="item in semesterOptions"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="阶段" prop="stage">
          <el-select
            v-model="form.stage"
            placeholder="请选择阶段"
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="item in stageOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="阶段名称" prop="stageName">
          <el-input v-model="form.stageName" placeholder="请输入阶段自定义名称" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" placeholder="请输入内容" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listOmdstageconfig, getOmdstageconfig, delOmdstageconfig, addOmdstageconfig, updateOmdstageconfig } from "@/api/system/stageconfig";
import { listMajors } from "@/api/OmdMajors/majors";
import { download } from "@/utils/request"; 

export default {
  name: "StageMian",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 阶段名管理表格数据
      omdstageconfigList: [],
      // 专业选项
      majorOptions: [],
      // 学期选项
      semesterOptions: [
        { value: '1', label: '第1学期' },
        { value: '2', label: '第2学期' },
        { value: '3', label: '第3学期' },
        { value: '4', label: '第4学期' },
        { value: '5', label: '第5学期' },
        { value: '6', label: '第6学期' }
      ],
      // 阶段选项
      stageOptions: [
        { value: 1, label: '第一阶段' },
        { value: 2, label: '第二阶段' },
        { value: 3, label: '第三阶段' },
        { value: 4, label: '第四阶段' },
        { value: 5, label: '第五阶段' },
        { value: 6, label: '第六阶段' },
        { value: 7, label: '第七阶段' },
        { value: 8, label: '第八阶段' }
      ],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        majorId: null,
        xueQi: null,
        stage: null,
        stageName: null,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        majorId: [
          { required: true, message: "请选择专业", trigger: "change" }
        ],
        xueQi: [
          { required: true, message: "请选择学期", trigger: "change" }
        ],
        stage: [
          { required: true, message: "请选择阶段", trigger: "change" }
        ],
        stageName: [
          { required: true, message: "请输入阶段名称", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.getMajorList();
    this.getList();
  },
  methods: {
    /** 查询专业列表 */
    getMajorList() {
      listMajors().then(response => {
        this.majorOptions = response.rows || [];
      });
    },
    /** 查询阶段名管理列表 */
    getList() {
      this.loading = true;
      listOmdstageconfig(this.queryParams).then(response => {
        this.omdstageconfigList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    /** 格式化学期显示 */
    formatSemester(value) {
      const semester = this.semesterOptions.find(item => item.value === value);
      return semester ? semester.label : value;
    },
    
    /**
     * 每页条数变化事件
     * @param {number} val 新的每页条数
     * @return {void}
     */
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },

    /**
     * 当前页变化事件
     * @param {number} val 新的页码
     * @return {void}
     */
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        majorId: null,
        xueQi: null,
        stage: null,
        stageName: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        remark: null
      };
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
     this.$refs.queryForm.resetFields();
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加阶段名管理";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids
      getOmdstageconfig(id).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改阶段名管理";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != null) {
            updateOmdstageconfig(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
              console.log(response)
            });
          } else {
            addOmdstageconfig(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
              console.log(response)
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$modal.confirm('是否确认删除阶段名管理编号为"' + ids + '"的数据项？').then(function() {
        return delOmdstageconfig(ids);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {

      download('/system/stageConfig/export', {
        ...this.queryParams
      }, `阶段名配置_${new Date().getTime()}.xlsx`)
    }
  }
};
</script>
<style scoped>
/* 主容器样式 */
.app-container {
  padding: 20px;
}

/* 表格操作按钮紧凑样式 */
.small-padding .el-button {
  padding: 5px;
  margin-left: 0;
}

/* 表格头部*/
::v-deep .el-table__header-wrapper .el-table__header th {
  background-color: #f4f4f4 !important;
  color: #000 !important;
}

/* 分页器样式 */
::v-deep .el-pager li.active {
  background-color: var(--primary-color) !important;
  color: white !important;
  border-color: var(--primary-color) !important;
  font-weight: bold;
  cursor: pointer;
}

/* 分页器样式 */
::v-deep .el-pager li.active:hover {
  background-color:#d6336c !important;
  color: white !important;
   background-color:  #d6336c!important;
  font-weight: bold;
  cursor: pointer;
}

/*按钮的样式 主要按钮 的样式*/
::v-deep .el-button--primary {
  color: #fff;
  background-color: var(--primary-color);
  border: 1px solid var(--primary-color);
}

/*鼠标获得焦点的样式*/
::v-deep .el-button--primary:hover {
  background-color:  #d6336c !important;
}

/* 在全局样式文件中添加 */
::v-deep .el-button:focus {
  outline: none !important;
  box-shadow: none !important;
}

/* 如果按钮是 plain 样式 */
::v-deep.el-button--plain:focus {
  outline: none !important;
  box-shadow: none !important;
}

::v-deep .el-button--primary:focus,
.el-button--primary:hover {
  background-color: var(--primary-color);
  border: none;
  color: #fff;
}

/* 文本框鼠标获得焦点边框 */
::v-deep .el-input__inner:focus {
  border-color: var(--primary-color) !important;
}

/* 如果是 textarea */
::v-deep .el-textarea__inner:focus {
  border-color: var(--primary-color) !important;
}

/* 在全局样式或组件样式中添加 */
::v-deep.confirm-delete-button {
  background-color: #f56c6c !important;
  border-color: #f56c6c !important;
}

::v-deep.confirm-delete-button:hover {
  background-color: #e05c5c !important;
  border-color: #e05c5c !important;
}
</style>